import { NEW_RULE } from '../constants'

export default (rule, newRuleId) => ({
    type: NEW_RULE,
    rule,
    newRuleId: newRuleId || 'NEW-' + new Date().getTime()
})
